var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("attachment-options")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("components.sales.show-on-print") },
                    model: {
                      value: _vm.doc.ShowWithPrint,
                      callback: function ($$v) {
                        _vm.$set(_vm.doc, "ShowWithPrint", $$v)
                      },
                      expression: "doc.ShowWithPrint",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: {
                      label: _vm.$ct("components.sales.show-on-download"),
                    },
                    model: {
                      value: _vm.doc.ShowWithDownload,
                      callback: function ($$v) {
                        _vm.$set(_vm.doc, "ShowWithDownload", $$v)
                      },
                      expression: "doc.ShowWithDownload",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("components.sales.show-on-send") },
                    model: {
                      value: _vm.doc.ShowWithSend,
                      callback: function ($$v) {
                        _vm.$set(_vm.doc, "ShowWithSend", $$v)
                      },
                      expression: "doc.ShowWithSend",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { disabled: _vm.isSaving, icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.isSaving, icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }